var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 0.333313L8.05967 1.27331L11.113 4.33331H0.333008V5.66665H11.113L8.05301 8.72665L8.99967 9.66665L13.6663 4.99998L8.99967 0.333313Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlack);
export default __webpack_public_path__ + "static/media/chevron_right_black.a012a900dde2a69701eea88f9198036a.svg";
export { ForwardRef as ReactComponent };